import { render, staticRenderFns } from "./backendFilter.vue?vue&type=template&id=4b366dda&scoped=true&"
import script from "./backendFilter.vue?vue&type=script&lang=js&"
export * from "./backendFilter.vue?vue&type=script&lang=js&"
import style0 from "./backendFilter.vue?vue&type=style&index=0&id=4b366dda&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b366dda",
  null
  
)

component.options.__file = "backendFilter.vue"
export default component.exports